export default {
	all_yout_user_data_will_be_deleted_and_this_process_isnt_reversible:
		"TOUTES VOS DONNÉES SERONT SUPPRIMÉES, C'EST IRRÉVERSIBLE!",
	check_in_on_a_event: 'participer à un évènement',
	commented_the_news: 'dépêches à commenter',
	earned_a_certification_on_the_trail: 'a reçu un certificat pour la piste.',
	earned_a_certification_on_the_training: 'a reçu un certificat pour la formation.',
	earned_the_badge: 'a reçu le badge',
	evaluated_the_podcast: 'a évalué le podcast',
	evaluated_the_trail: 'a évalué la piste',
	evaluated_the_training: 'a évalué la formation',
	extra_activity: 'activité supplémentaire',
	favorited_the_podcast: 'a ajouté en favoris le podcast',
	favorited_the_trail: 'a favorisé la piste',
	favorited_the_training: 'a favorisé la formation',
	liked_the_podcast: 'a apprécié le podcast',
	liked_the_trail: 'a apprécié la piste',
	liked_the_training: 'a apprécié la formation',
	liked_the_live_class: 'a apprécié la classe en direct',
	liked_the_presential_event: 'a apprécié le événement présent',
	evaluated_the_presential_event: 'a évalué le événement présent',
	evaluated_the_live_class: 'a évalué la classe en direct',
	new_sale_informed: 'nouvelle vente informée',
	points_were_awarded_for: 'Des points ont été attribué pour',
	the_file: 'Le fichier',
	the_product: 'Le produit',
	the_trail: 'Le piste',
	the_training: 'Le formation',
	the_webinar: 'Le Webinaire',
	close_account: 'Fermer le compte ',
	there_are_no_activities_at_the_moment: 'Aucune activité pour l’instant.',
	training_finished_on_irep: 'formation terminée sur Intel® Retail Edge Program',
	upgrading_to_level: 'mise à niveau au niveau',
	was_published_f: 'a été publiée',
	was_published_on_the_library: 'a été publié dans la bibliothèque',
	was_published: 'a été publié',
	was_purchased: 'a été acheté',
	i_do_confirm_the_deletion_of_my_user_data: 'CONFIRMER LA FERMETURE DU COMPTE',
	to_confirm_enter_your_name: 'Pour continuer, entrez votre nom:',
}
